var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgFavorites = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#favorites_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M19.967 7.562a1.05 1.05 0 0 0-.33-.484.97.97 0 0 0-.53-.217l-5.682-.867L10.88.59a1.03 1.03 0 0 0-.369-.43.97.97 0 0 0-1.06 0 1.03 1.03 0 0 0-.369.43L6.535 5.983l-5.683.878a1 1 0 0 0-.501.235c-.143.125-.25.29-.307.476a1.1 1.1 0 0 0-.014.559c.044.184.135.352.263.486L4.418 12.8l-.999 5.937c-.04.197-.025.402.043.59s.187.352.342.471a.96.96 0 0 0 1.083.067l5.093-2.79 5.093 2.79c.14.083.299.127.46.126a.97.97 0 0 0 .589-.198 1.04 1.04 0 0 0 .345-.462c.071-.185.09-.388.054-.584l-.998-5.937 4.124-4.181a1.05 1.05 0 0 0 .307-.485c.057-.189.061-.39.012-.581",
  clipRule: "evenodd"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "favorites_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h20v20H0z"
})))));
export default SvgFavorites;